import { createContext } from 'react';
import { SeoProject } from '@/types/api/seo';

type SeoProjectContextType = {
  project: SeoProject | undefined;
  refetchProject: () => void;
  isLoadingProject: boolean;
  breadcrumbDetail: string | null;
  setBreadcrumbDetail: (label: string | null) => void;
};

const context = createContext<SeoProjectContextType>({
  refetchProject() {},
  isLoadingProject: false,
  project: undefined,
  breadcrumbDetail: null,
  setBreadcrumbDetail() {},
});

export default context;
